export { default, Props } from './CopyText';
